module.exports = __webpack_public_path__ + "img/userB21.658bd00c.jpg";